import React, { Component } from "react";
import { Layout, Menu, Row, Col, Icon } from "antd";
import { Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "../App.css";

import * as actions from "../store/actions";

import PrivateRoute from "../components/common/router/PrivateRoute";
import List from "./List";
import NewResearch from "./NewResearch";
import Research from "./Research";
import Category from "./Category";
import Camera from "./Camera";
import User from "./User";
import Config from "./Config";
import NewUser from "./NewUser";
import ListUser from "./ListUser";
import soap_cadastrar_pesquisa from "../store/soap/zws_app_cadastrar_pesquisa.js";

import logo from "../assets/dmalogo.png";

const { Header, Content } = Layout;

class Dashboard extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.Offline.on("up", () => {
        let save = localStorage.getItem("savePesquisa");
        if (save !== null) {
          soap_cadastrar_pesquisa.postCadastrarPesquisa(JSON.parse(save));
        }
      });
    }, 1000);
  }

  render() {
    const { pathname } = this.props.location;
    let span = 22;
    let offset = 1;
    if (pathname.includes("scan") || pathname.includes("pic")) {
      span = 24;
      offset = 0;
    }
    return (
      <Layout>
        <Header>
          {this.props.history.location.pathname !== "/" && (
            <Icon
              type="caret-left"
              onClick={() => this.props.history.goBack(-1)}
              style={{
                fontSize: 24,
                marginTop: 20,
                marginLeft: 15,
                color: "#fff",
                verticalAlign: "center",
                float: "left",
              }}
            />
          )}

          <div className="logoDMA">
            <img src={logo} alt="DMA" height="48" />
          </div>
          <Menu theme="dark" mode="horizontal" className="dma-menu">
            {JSON.parse(localStorage.getItem("user")).role === "admin" && (
              <Menu.Item
                key="3"
                onClick={() => this.props.history.push("/config")}
              >
                <Icon
                  type="setting"
                  style={{
                    fontSize: 18,
                    color: "#fff",
                    padding: 7,
                    verticalAlign: "center",
                    float: "right",
                  }}
                />
              </Menu.Item>
            )}
            <Menu.Item key="2" onClick={() => this.props.history.push("/user")}>
              <Icon
                type="user"
                style={{
                  fontSize: 18,
                  color: "#fff",
                  padding: 7,
                  verticalAlign: "center",
                  float: "right",
                }}
              />
            </Menu.Item>
            <Menu.Item key="1" onClick={() => this.props.onLogOut()}>
              <Icon
                type="logout"
                style={{
                  fontSize: 18,
                  color: "#fff",
                  padding: 7,
                  verticalAlign: "center",
                  float: "right",
                }}
              />
            </Menu.Item>
          </Menu>
        </Header>
        <Content style={{ backgroundColor: "#fff" }}>
          <Row>
            <Col xs={{ span, offset }} lg={{ span: 8, offset: 8 }}>
              <Switch>
                <PrivateRoute exact path="/" component={List} />
                <PrivateRoute
                  exact
                  path="/research/new"
                  component={NewResearch}
                />
                <PrivateRoute exact path="/category/:id" component={Category} />
                <PrivateRoute exact path="/research/:id" component={Research} />
                {/* <PrivateRoute
                  exact
                  path="/research/:reasearchId/product/scan"
                  component={Camera}
                />
                <PrivateRoute
                  exact
                  path="/research/:reasearchId/product/:productId/pic"
                  component={Camera}
                /> */}
                <PrivateRoute exact path="/user" component={User} />
                <PrivateRoute exact path="/user/new" component={NewUser} />
                <PrivateRoute exact path="/user/list" component={ListUser} />
                {JSON.parse(localStorage.getItem("user")).role === "admin" && (
                  <PrivateRoute exact path="/config" component={Config} />
                )}
              </Switch>
            </Col>
          </Row>
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLogOut: () => dispatch(actions.logOut()),
});

export default connect(null, mapDispatchToProps)(withRouter(Dashboard));
